import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const AgileExpertIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M23 23.0833V7.08334H4.99997V15.0833H2.99997V7.08334C2.99997 6.53334 3.1958 6.06251 3.58747 5.67084C3.97914 5.27918 4.44997 5.08334 4.99997 5.08334H23C23.55 5.08334 24.0208 5.27918 24.4125 5.67084C24.8041 6.06251 25 6.53334 25 7.08334V21.0833C25 21.6333 24.8041 22.1042 24.4125 22.4958C24.0208 22.8875 23.55 23.0833 23 23.0833ZM8.17497 14.9083C7.39164 14.125 6.99997 13.1833 6.99997 12.0833C6.99997 10.9833 7.39164 10.0417 8.17497 9.25834C8.9583 8.47501 9.89997 8.08334 11 8.08334C12.1 8.08334 13.0416 8.47501 13.825 9.25834C14.6083 10.0417 15 10.9833 15 12.0833C15 13.1833 14.6083 14.125 13.825 14.9083C13.0416 15.6917 12.1 16.0833 11 16.0833C9.89997 16.0833 8.9583 15.6917 8.17497 14.9083ZM2.99997 24.0833V21.2833C2.99997 20.7167 3.1458 20.1958 3.43747 19.7208C3.72914 19.2458 4.11664 18.8833 4.59997 18.6333C5.6333 18.1167 6.6833 17.7292 7.74997 17.4708C8.81664 17.2125 9.89997 17.0833 11 17.0833C12.1 17.0833 13.1833 17.2125 14.25 17.4708C15.3166 17.7292 16.3666 18.1167 17.4 18.6333C17.8833 18.8833 18.2708 19.2458 18.5625 19.7208C18.8541 20.1958 19 20.7167 19 21.2833V24.0833H2.99997Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const ArchitectIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M17.3 24V20.6667H12.9V9.55556H10.7V12.8889H3V4H10.7V7.33333H17.3V4H25V12.8889H17.3V9.55556H15.1V18.4444H17.3V15.1111H25V24H17.3Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const DataAIEngineerIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M9.15755 24C8.9316 24 8.72104 23.9427 8.5259 23.8281C8.33076 23.7135 8.18183 23.5521 8.07912 23.3438L5.67576 19H7.46287L8.69537 21.5H11.5301V20.25H9.43486L8.20237 17.75H4.99789L3.24159 14.625C3.2005 14.5208 3.16456 14.4167 3.13374 14.3125C3.10293 14.2083 3.08752 14.1042 3.08752 14C3.08752 13.9167 3.13888 13.7083 3.24159 13.375L4.99789 10.25H8.20237L9.43486 7.75H11.5301V6.5H8.69537L7.46287 9H5.67576L8.07912 4.65625C8.18183 4.44792 8.33076 4.28646 8.5259 4.17188C8.72104 4.05729 8.9316 4 9.15755 4H12.1463C12.4956 4 12.7883 4.11979 13.0245 4.35938C13.2607 4.59896 13.3788 4.89583 13.3788 5.25V10.25H11.5301L10.2976 11.5H13.3788V15.25H10.6674L9.43486 12.75H6.60013L5.36764 14H8.69537L9.92786 16.5H13.3788V22.75C13.3788 23.1042 13.2607 23.401 13.0245 23.6406C12.7883 23.8802 12.4956 24 12.1463 24H9.15755ZM14.7192 23.2656C14.2365 22.776 13.9951 22.1875 13.9951 21.5C13.9951 21.0208 14.1081 20.599 14.334 20.2344C14.56 19.8698 14.8578 19.5729 15.2276 19.3438V8.65625C14.8578 8.42708 14.56 8.13021 14.334 7.76562C14.1081 7.40104 13.9951 6.97917 13.9951 6.5C13.9951 5.8125 14.2365 5.22396 14.7192 4.73438C15.2019 4.24479 15.7822 4 16.4601 4C17.1379 4 17.7182 4.24479 18.201 4.73438C18.6837 5.22396 18.9251 5.8125 18.9251 6.5C18.9251 6.97917 18.8121 7.40104 18.5861 7.76562C18.3602 8.13021 18.0623 8.42708 17.6926 8.65625V11.8125L20.1576 10.3125C20.1576 9.60417 20.3989 9 20.8816 8.5C21.3644 8 21.9447 7.75 22.6225 7.75C23.3004 7.75 23.8807 7.99479 24.3634 8.48438C24.8462 8.97396 25.0875 9.5625 25.0875 10.25C25.0875 10.9375 24.8462 11.526 24.3634 12.0156C23.8807 12.5052 23.3004 12.75 22.6225 12.75C22.3966 12.75 22.186 12.724 21.9909 12.6719C21.7957 12.6198 21.6057 12.5417 21.4209 12.4375L18.6169 14.1562L21.729 16.6562C21.8728 16.5938 22.0166 16.5521 22.1604 16.5312C22.3041 16.5104 22.4582 16.5 22.6225 16.5C23.3004 16.5 23.8807 16.7448 24.3634 17.2344C24.8462 17.724 25.0875 18.3125 25.0875 19C25.0875 19.6875 24.8462 20.276 24.3634 20.7656C23.8807 21.2552 23.3004 21.5 22.6225 21.5C21.8625 21.5 21.2411 21.2083 20.7584 20.625C20.2757 20.0417 20.0857 19.375 20.1884 18.625L17.6926 16.5938V19.375C18.0623 19.6042 18.355 19.901 18.5707 20.2656C18.7864 20.6302 18.8942 21.0417 18.8942 21.5C18.8942 22.1875 18.658 22.776 18.1856 23.2656C17.7131 23.7552 17.1379 24 16.4601 24C15.7822 24 15.2019 23.7552 14.7192 23.2656Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const DevOpsPlatformEngineerIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M8.5 22C6.98333 22 5.6875 21.475 4.6125 20.425C3.5375 19.375 3 18.0917 3 16.575C3 15.275 3.39167 14.1167 4.175 13.1C4.95833 12.0833 5.98333 11.4333 7.25 11.15C7.66667 9.61667 8.5 8.375 9.75 7.425C11 6.475 12.4167 6 14 6C15.95 6 17.6042 6.67917 18.9625 8.0375C20.3208 9.39583 21 11.05 21 13C22.15 13.1333 23.1042 13.6292 23.8625 14.4875C24.6208 15.3458 25 16.35 25 17.5C25 18.75 24.5625 19.8125 23.6875 20.6875C22.8125 21.5625 21.75 22 20.5 22H8.5Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const EmbeddedIntegrationEngineerIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M10.3333 17.6667V10.3333H17.6667V17.6667H10.3333ZM10.3333 25V22.5556H7.88889C7.21667 22.5556 6.6412 22.3162 6.1625 21.8375C5.6838 21.3588 5.44444 20.7833 5.44444 20.1111V17.6667H3V15.2222H5.44444V12.7778H3V10.3333H5.44444V7.88889C5.44444 7.21667 5.6838 6.6412 6.1625 6.1625C6.6412 5.6838 7.21667 5.44444 7.88889 5.44444H10.3333V3H12.7778V5.44444H15.2222V3H17.6667V5.44444H20.1111C20.7833 5.44444 21.3588 5.6838 21.8375 6.1625C22.3162 6.6412 22.5556 7.21667 22.5556 7.88889V10.3333H25V12.7778H22.5556V15.2222H25V17.6667H22.5556V20.1111C22.5556 20.7833 22.3162 21.3588 21.8375 21.8375C21.3588 22.3162 20.7833 22.5556 20.1111 22.5556H17.6667V25H15.2222V22.5556H12.7778V25H10.3333ZM20.1111 20.1111V7.88889H7.88889V20.1111H20.1111Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const LeadershipManagementIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M14.11 24C13.7983 24 13.5371 23.8935 13.3263 23.6806C13.1154 23.4676 13.01 23.2037 13.01 22.8889C13.01 22.7593 13.0375 22.625 13.0925 22.4861C13.1475 22.3472 13.23 22.2222 13.34 22.1111L18.4275 16.9722L17.63 16.1667L12.57 21.3056C12.46 21.4167 12.3408 21.5 12.2125 21.5556C12.0842 21.6111 11.9467 21.6389 11.8 21.6389C11.4883 21.6389 11.2271 21.5324 11.0162 21.3194C10.8054 21.1065 10.7 20.8426 10.7 20.5278C10.7 20.3426 10.7275 20.1898 10.7825 20.0694C10.8375 19.9491 10.9108 19.8426 11.0025 19.75L16.09 14.6111L15.32 13.8333L10.2325 18.9444C10.1225 19.0556 10.0033 19.1389 9.875 19.1944C9.74667 19.25 9.6 19.2778 9.435 19.2778C9.14167 19.2778 8.885 19.1667 8.665 18.9444C8.445 18.7222 8.335 18.463 8.335 18.1667C8.335 18.0185 8.3625 17.8796 8.4175 17.75C8.4725 17.6204 8.555 17.5 8.665 17.3889L13.7525 12.25L12.955 11.4722L7.895 16.6111C7.80333 16.7037 7.69333 16.7778 7.565 16.8333C7.43667 16.8889 7.28083 16.9167 7.0975 16.9167C6.78583 16.9167 6.52458 16.8102 6.31375 16.5972C6.10292 16.3843 5.9975 16.1204 5.9975 15.8056C5.9975 15.6574 6.025 15.5185 6.08 15.3889C6.135 15.2593 6.2175 15.1389 6.3275 15.0278L12.46 8.83333L16.585 13.0278C16.7867 13.2315 17.025 13.3935 17.3 13.5139C17.575 13.6343 17.85 13.6944 18.125 13.6944C18.7117 13.6944 19.225 13.4861 19.665 13.0694C20.105 12.6528 20.325 12.1204 20.325 11.4722C20.325 11.213 20.2792 10.9444 20.1875 10.6667C20.0958 10.3889 19.9308 10.1296 19.6925 9.88889L14.77 4.91667C15.0817 4.62037 15.43 4.39352 15.815 4.23611C16.2 4.0787 16.585 4 16.97 4C17.4467 4 17.8867 4.0787 18.29 4.23611C18.6933 4.39352 19.06 4.63889 19.39 4.97222L24.0375 9.69444C24.3675 10.0278 24.6104 10.3981 24.7663 10.8056C24.9221 11.213 25 11.6852 25 12.2222C25 12.5926 24.9175 12.9676 24.7525 13.3472C24.5875 13.7269 24.3492 14.0741 24.0375 14.3889L14.88 23.6667C14.7333 23.8148 14.605 23.9074 14.495 23.9444C14.385 23.9815 14.2567 24 14.11 24ZM4.6775 15.1111L3.9625 14.3889C3.65083 14.0926 3.4125 13.7407 3.2475 13.3333C3.0825 12.9259 3 12.5 3 12.0556C3 11.5741 3.09167 11.1296 3.275 10.7222C3.45833 10.3148 3.6875 9.97222 3.9625 9.69444L8.61 4.97222C8.90333 4.67593 9.25167 4.43981 9.655 4.26389C10.0583 4.08796 10.4525 4 10.8375 4C11.3325 4 11.7725 4.06944 12.1575 4.20833C12.5425 4.34722 12.9183 4.60185 13.285 4.97222L18.9225 10.6667C19.0325 10.7778 19.115 10.8981 19.17 11.0278C19.225 11.1574 19.2525 11.2963 19.2525 11.4444C19.2525 11.7407 19.1425 12 18.9225 12.2222C18.7025 12.4444 18.4458 12.5556 18.1525 12.5556C17.9875 12.5556 17.85 12.5324 17.74 12.4861C17.63 12.4398 17.5108 12.3519 17.3825 12.2222L12.4325 7.27778L4.6775 15.1111Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const ProductProjectManagerIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    {...props}
  >
    <path
      d="M2.33333 23.3333C1.69167 23.3333 1.14236 23.1049 0.685417 22.6479C0.228472 22.191 0 21.6417 0 21V4.66667C0 4.025 0.228472 3.47569 0.685417 3.01875C1.14236 2.56181 1.69167 2.33333 2.33333 2.33333H7.23333C7.48611 1.63333 7.90903 1.06944 8.50208 0.641667C9.09514 0.213889 9.76111 0 10.5 0C11.2389 0 11.9049 0.213889 12.4979 0.641667C13.091 1.06944 13.5139 1.63333 13.7667 2.33333H18.6667C19.3083 2.33333 19.8576 2.56181 20.3146 3.01875C20.7715 3.47569 21 4.025 21 4.66667V21C21 21.6417 20.7715 22.191 20.3146 22.6479C19.8576 23.1049 19.3083 23.3333 18.6667 23.3333H2.33333ZM4.66667 18.6667H12.8333V16.3333H4.66667V18.6667ZM4.66667 14H16.3333V11.6667H4.66667V14ZM4.66667 9.33333H16.3333V7H4.66667V9.33333ZM10.5 3.79167C10.7528 3.79167 10.9618 3.70903 11.1271 3.54375C11.2924 3.37847 11.375 3.16944 11.375 2.91667C11.375 2.66389 11.2924 2.45486 11.1271 2.28958C10.9618 2.12431 10.7528 2.04167 10.5 2.04167C10.2472 2.04167 10.0382 2.12431 9.87292 2.28958C9.70764 2.45486 9.625 2.66389 9.625 2.91667C9.625 3.16944 9.70764 3.37847 9.87292 3.54375C10.0382 3.70903 10.2472 3.79167 10.5 3.79167Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const QAEngineerIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    {...props}
  >
    <path
      d="M10 22C8.64583 22 7.39062 21.6741 6.23438 21.0222C5.07812 20.3704 4.16667 19.4741 3.5 18.3333H0V15.8889H2.625C2.5625 15.4815 2.52604 15.0741 2.51562 14.6667C2.50521 14.2593 2.5 13.8519 2.5 13.4444H0V11H2.5C2.5 10.5926 2.50521 10.1852 2.51562 9.77778C2.52604 9.37037 2.5625 8.96296 2.625 8.55556H0V6.11111H3.5C3.79167 5.64259 4.11979 5.20463 4.48438 4.79722C4.84896 4.38981 5.27083 4.03333 5.75 3.72778L3.75 1.71111L5.5 0L8.1875 2.62778C8.77083 2.44444 9.36458 2.35278 9.96875 2.35278C10.5729 2.35278 11.1667 2.44444 11.75 2.62778L14.5 0L16.25 1.71111L14.1875 3.72778C14.6667 4.03333 15.099 4.38472 15.4844 4.78194C15.8698 5.17917 16.2083 5.62222 16.5 6.11111H20V8.55556H17.375C17.4375 8.96296 17.474 9.37037 17.4844 9.77778C17.4948 10.1852 17.5 10.5926 17.5 11H20V13.4444H17.5C17.5 13.8519 17.4948 14.2593 17.4844 14.6667C17.474 15.0741 17.4375 15.4815 17.375 15.8889H20V18.3333H16.5C15.8333 19.4741 14.9219 20.3704 13.7656 21.0222C12.6094 21.6741 11.3542 22 10 22ZM7.5 15.8889H12.5V13.4444H7.5V15.8889ZM7.5 11H12.5V8.55556H7.5V11Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const SecurityComplianceEngineerIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    {...props}
  >
    <path
      d="M9 24C6.39375 23.3 4.24219 21.705 2.54531 19.215C0.848437 16.725 0 13.96 0 10.92V3.6L9 0L18 3.6V10.92C18 13.96 17.1516 16.725 15.4547 19.215C13.7578 21.705 11.6062 23.3 9 24ZM6.75 16.8H11.25C11.5687 16.8 11.8359 16.685 12.0516 16.455C12.2672 16.225 12.375 15.94 12.375 15.6V12C12.375 11.66 12.2672 11.375 12.0516 11.145C11.8359 10.915 11.5687 10.8 11.25 10.8V9.6C11.25 8.94 11.0297 8.375 10.5891 7.905C10.1484 7.435 9.61875 7.2 9 7.2C8.38125 7.2 7.85156 7.435 7.41094 7.905C6.97031 8.375 6.75 8.94 6.75 9.6V10.8C6.43125 10.8 6.16406 10.915 5.94844 11.145C5.73281 11.375 5.625 11.66 5.625 12V15.6C5.625 15.94 5.73281 16.225 5.94844 16.455C6.16406 16.685 6.43125 16.8 6.75 16.8ZM7.875 10.8V9.6C7.875 9.26 7.98281 8.975 8.19844 8.745C8.41406 8.515 8.68125 8.4 9 8.4C9.31875 8.4 9.58594 8.515 9.80156 8.745C10.0172 8.975 10.125 9.26 10.125 9.6V10.8H7.875Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const SoftwareEngineerIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
    {...props}
  >
    <path
      d="M6.6 14L0 7L6.6 0L8.1675 1.6625L3.1075 7.02917L8.14 12.3667L6.6 14ZM15.4 14L13.8325 12.3375L18.8925 6.97083L13.86 1.63333L15.4 0L22 7L15.4 14Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const UXDesignerResearcherIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    {...props}
  >
    <path
      d="M7.14 9.3975L9.3975 7.11375L7.9275 5.6175L6.7725 6.7725L5.3025 5.3025L6.43125 4.1475L5.25 2.96625L2.96625 5.25L7.14 9.3975ZM15.75 18.0337L18.0337 15.75L16.8525 14.5687L15.6975 15.6975L14.2275 14.2275L15.3562 13.0725L13.86 11.6025L11.6025 13.86L15.75 18.0337ZM14.9362 4.64625L16.4062 6.11625L17.8762 4.64625L16.38 3.15L14.9362 4.64625ZM5.5125 19.95H1.05V15.4875L5.64375 10.8937L0 5.25L5.25 0L10.92 5.67L14.8837 1.68C15.0938 1.47 15.33 1.3125 15.5925 1.2075C15.855 1.1025 16.1262 1.05 16.4062 1.05C16.6862 1.05 16.9575 1.1025 17.22 1.2075C17.4825 1.3125 17.7188 1.47 17.9287 1.68L19.32 3.0975C19.53 3.3075 19.6875 3.54375 19.7925 3.80625C19.8975 4.06875 19.95 4.34 19.95 4.62C19.95 4.9 19.8975 5.16687 19.7925 5.42062C19.6875 5.67438 19.53 5.90625 19.32 6.11625L15.3562 10.1062L21 15.75L15.75 21L10.1062 15.3562L5.5125 19.95Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const OtherIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M12.3171 18.0526C12.3171 16.4895 12.4501 15.3654 12.7162 14.6803C12.9823 13.9952 13.5465 13.2474 14.4089 12.4368C15.1612 11.7421 15.7345 11.139 16.129 10.6276C16.5235 10.1162 16.7208 9.53246 16.7208 8.87632C16.7208 8.08509 16.4685 7.42895 15.9639 6.90789C15.4593 6.38684 14.7575 6.12632 13.8584 6.12632C12.9226 6.12632 12.2116 6.42544 11.7254 7.02368C11.2391 7.62193 10.8951 8.22982 10.6933 8.84737L7.8584 7.57368C8.24372 6.3386 8.95014 5.26754 9.97766 4.36053C11.0052 3.45351 12.2988 3 13.8584 3C15.785 3 17.2667 3.56447 18.3034 4.69342C19.34 5.82237 19.8584 7.17807 19.8584 8.76053C19.8584 9.72544 19.6612 10.5504 19.2667 11.2355C18.8722 11.9206 18.2529 12.6974 17.4089 13.5658C16.5098 14.4728 15.9639 15.1627 15.7712 15.6355C15.5786 16.1083 15.4823 16.914 15.4823 18.0526H12.3171ZM13.8584 25C13.2529 25 12.7345 24.7732 12.3034 24.3197C11.8722 23.8662 11.6566 23.3211 11.6566 22.6842C11.6566 22.0474 11.8722 21.5022 12.3034 21.0487C12.7345 20.5952 13.2529 20.3684 13.8584 20.3684C14.4639 20.3684 14.9823 20.5952 15.4134 21.0487C15.8446 21.5022 16.0602 22.0474 16.0602 22.6842C16.0602 23.3211 15.8446 23.8662 15.4134 24.3197C14.9823 24.7732 14.4639 25 13.8584 25Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const interestedIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M20.9999 24.5H9.33325V9.33332L17.4999 1.16666L18.9583 2.62499C19.0944 2.7611 19.2062 2.94582 19.2937 3.17916C19.3812 3.41249 19.4249 3.6361 19.4249 3.84999V4.25832L18.1416 9.33332H24.4999C25.1221 9.33332 25.6666 9.56666 26.1333 10.0333C26.5999 10.5 26.8333 11.0444 26.8333 11.6667V14C26.8333 14.1361 26.8187 14.2819 26.7895 14.4375C26.7603 14.593 26.7166 14.7389 26.6583 14.875L23.1583 23.1C22.9833 23.4889 22.6916 23.8194 22.2833 24.0917C21.8749 24.3639 21.4471 24.5 20.9999 24.5ZM6.99992 9.33332V24.5H2.33325V9.33332H6.99992Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const notInterestedIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M14.9332 26.8333C13.3388 26.8333 11.8416 26.4687 10.4416 25.7396C9.04157 25.0104 7.89435 23.9944 6.9999 22.6917L1.3999 14.4667L1.95407 13.9125C2.34296 13.5042 2.82421 13.2708 3.39782 13.2125C3.97143 13.1542 4.49157 13.2903 4.95824 13.6208L8.16657 15.8375V4.66666C8.16657 4.3361 8.27837 4.05902 8.50199 3.83541C8.7256 3.6118 9.00268 3.49999 9.33324 3.49999C9.66379 3.49999 9.94088 3.6118 10.1645 3.83541C10.3881 4.05902 10.4999 4.3361 10.4999 4.66666V14H12.8332V2.33332C12.8332 2.00277 12.945 1.72568 13.1687 1.50207C13.3923 1.27846 13.6693 1.16666 13.9999 1.16666C14.3305 1.16666 14.6075 1.27846 14.8312 1.50207C15.0548 1.72568 15.1666 2.00277 15.1666 2.33332V14H17.4999V3.49999C17.4999 3.16943 17.6117 2.89235 17.8353 2.66874C18.0589 2.44513 18.336 2.33332 18.6666 2.33332C18.9971 2.33332 19.2742 2.44513 19.4978 2.66874C19.7214 2.89235 19.8332 3.16943 19.8332 3.49999V14H22.1666V5.83332C22.1666 5.50277 22.2784 5.22568 22.502 5.00207C22.7256 4.77846 23.0027 4.66666 23.3332 4.66666C23.6638 4.66666 23.9409 4.77846 24.1645 5.00207C24.3881 5.22568 24.4999 5.50277 24.4999 5.83332V17.2667C24.4999 19.9305 23.5714 22.191 21.7145 24.0479C19.8575 25.9049 17.5971 26.8333 14.9332 26.8333Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const RadioIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="9.25"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </SvgIcon>
);
